// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"860":"7c6ff55c","976":"533d9f7a"}[chunkId] + ".chunk.css";
};